import ChangeHistoryTamplate from "components/templates/ChangeHistoryTamplate"

const ChangeHistory = () => {
    return(
       <ChangeHistoryTamplate/>
    )

}

export default ChangeHistory